import { render, staticRenderFns } from "./PublicApp.vue?vue&type=template&id=701ac25d&"
import script from "./PublicApp.vue?vue&type=script&lang=js&"
export * from "./PublicApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports